"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThirdPartyAuthService = void 0;
const axios_1 = require("axios");
const abstract_service_1 = require("../shared/abstract-service");
class ThirdPartyAuthService extends abstract_service_1.AbstractService {
    getJitsiKey(campusId, areaId, roomId, envFlavor) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.baseUrl}/jitsi/key`, {
                campusId: campusId,
                areaId: areaId,
                roomId: roomId,
                envFlavor: envFlavor
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
    getPusherAuth(campusId, areaId, socketId, channelType) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.baseUrl}/pusher/auth`, {
                campusId: campusId,
                areaId: areaId,
                socketId: socketId,
                channelType: channelType
            }, {
                headers: this.getHeaders()
            });
            if (response.status != 200) {
                throw new Error(response.statusText);
            }
            return response.data;
        });
    }
}
exports.ThirdPartyAuthService = ThirdPartyAuthService;
